<template>
  <div>
    <el-breadcrumb
      separator-class="el-icon-arrow-right"
      style="margin-bottom:40px"
    >
      <el-breadcrumb-item :to="{ path: '/userTab' }"
        >企业信息</el-breadcrumb-item
      >
      <el-breadcrumb-item>企业认证</el-breadcrumb-item>
    </el-breadcrumb>
    <el-card>
      <div class="xingxi">
        <div class="tiao"></div>
        <i>企业用户认证</i>
      </div>
      <div class="biaodan">
        <el-form
          label-position="top"
          label-width="80px"
          :model="userForm"
          ref="userForm"
          :rules="userRules"
        >
          <el-form-item label="企业名称">
            <el-input
              type="textarea"
              autosize
              :disabled="true"
              v-model="userForm.companyName"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="企业地址"
            prop="companyAddress"
            hide-required-asterisk="true"
          >
            <v-distpicker
              hide-area
              @province="onChangeProvince"
              @city="onChangeCity"
            ></v-distpicker>
            <el-input
              type="textarea"
              autosize
              style="margin-top: 10px;"
              v-model="userForm.companyAddress"
              placeholder="请输入详细企业地址"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="联系人"
            prop="name"
            hide-required-asterisk="true"
          >
            <el-input
              v-model="userForm.name"
              placeholder="请输入联系人"
            ></el-input>
          </el-form-item>

          <el-form-item
            label="联系电话"
            prop="contacts"
            hide-required-asterisk="true"
          >
            <el-input
              type="textarea"
              autosize
              v-model="userForm.contacts"
              placeholder="请输入联系电话"
            ></el-input>
          </el-form-item>
          <el-form-item class="saomianjian">
            <div>
              <i class="bitianshangchuan"
                ><span style="color: #f56c6c;">*</span> 授权函上传：</i
              >
            </div>

            <el-upload
              ref="my-upload"
              class="upload-demo"
              action="general/upload"
              :on-remove="handleRemoveshouquan"
              :before-remove="beforeRemove"
              multiple
              :limit="1"
              :http-request="shouquanhan"
              :on-exceed="handleExceed"
              accept=".pdf"
              :file-list="fileList"
              :headers="myHeaders"
            >
              <el-button
                size="small"
                type="primary"
                style="display: inline-block;"
                >点击上传</el-button
              >
              <div
                style="display: inline-block;margin-left: 10px;"
                slot="tip"
                class="el-upload__tip"
              >
                请上传pdf格式的授权函
              </div>
            </el-upload>
          </el-form-item>
          <el-link
            target="_blank"
            download="原授权函"
            style="font-size: 12px;margin-right: 20px;"
            type="primary"
            icon="el-icon-download"
            :href="shouquanhanxiazai"
            >原授权函下载查看</el-link
          >
          <el-link
            download="平行世界注册申请授权书.docx"
            style="font-size: 12px;"
            type="primary"
            icon="el-icon-download"
            href="./tpls/powerOfAttorney.docx"
            >授权函模板下载</el-link
          >
        </el-form>
      </div>
      <div class="shangchuan">
        <div style=" margin-top: 30px;margin-bottom: 30px;">
          <div class="shenfen">
            <i style="color:red">*</i> 法人身份证扫描件：
          </div>
          <div class="zhengmian">
            <input
              class="fileOne"
              name="file"
              type="file"
              accept="image/png,image/gif,image/jpeg"
              @change="positive"
            />
            <img v-bind:src="positiveUrl" alt="" />

            <img class="mask" src="../../assets/img/jia.png" alt="" />
          </div>
          <div class="fanmian">
            <input
              class="fileOne"
              name="file"
              type="file"
              accept="image/png,image/gif,image/jpeg"
              @change="back"
            />
            <img v-bind:src="backUrl" alt="" />
            <img class="mask" src="../../assets/img/jia.png" alt="" />
          </div>
        </div>
        <div style=" margin-top: 30px;">
          <div class="yingye"><i style="color:red">*</i> 营业执照扫描件：</div>
          <div class="zhizhao">
            <input
              class="fileOne"
              name="file"
              type="file"
              accept="image/png,image/gif,image/jpeg"
              @change="license"
            />
            <img v-bind:src="licenseUrl" alt="" />
            <img class="mask" src="../../assets/img/jia.png" alt="" />
          </div>
        </div>

        <div v-if="this.bohuizhuantai">
          <div>
            <i style="color: #f56c6c;" class="bitianshangchuan"> 驳回原因：</i>
          </div>
          <el-input
            :disabled="true"
            :rows="4"
            type="textarea"
            v-model="userForm.bohuiyuanyin"
          ></el-input>
        </div>
      </div>
      <div class="tijiao-button">
        <el-button type="primary" @click="submission()">提交确认</el-button>
      </div>
    </el-card>
  </div>

  <!-- <el-row>
      <el-col :span="2" style="height:10px"> </el-col>
      <el-col :span="20">
        
      </el-col>
      <el-col :span="2" style="height:10px"> </el-col>
    </el-row> -->
</template>

<script>
import VDistpicker from "v-distpicker";
export default {
  components: { VDistpicker },
  data() {
    return {
      bohuizhuantai: false,
      shouquanhanxiazai: "",
      myHeaders: { "Content-Type": "multipart/form-data" },
      fileList: [],
      shouquanhanUpload: false,
      shouquanhanU: "",
      positiveUpload: false,
      backUpload: false,
      licenseUpload: false,
      positiveUrl: require("../../assets/img/shenfenzqian.png"),
      backUrl: require("../../assets/img/shenfenzbei.png"),
      licenseUrl: require("../../assets/img/zhengjian.png"),
      userForm: {
        companyName: "",
        companyAddress: "",
        name: "",
        contacts: "",
        bohuiyuanyin: ""
      },
      //上传用户填写信息
      fillData: {
        data: { companyAddress: "", name: "", contacts: "" }
      },

      //检验规则
      userRules: {
        companyAddress: [
          { required: true, message: "企业地址必填", trigger: "blur" }
        ],
        name: [{ required: true, message: "联系人必填", trigger: "blur" }],
        contacts: [{ required: true, message: "联系电话必填", trigger: "blur" }]
      },
      //上传认证
      companydate: {
        type: 1,
        userJsonData: { data: {} }
      },

      //添加属性
      udate: {
        function: "t_user",
        id: "",
        jsonData: { data: "" }
      },
      positiveU: "",
      backU: "",
      licenseU: "",
      testData: {},
      data: {},
      chengshi: "",
      shiqu: "",
      application: {
        host: "parallelword@terra-it.cn",

        title: "平行世界",
        content: ""
      }
    };
  },
  created() {
    this.sessionData();
  },
  methods: {
    async submit() {
      var content = `平行世界有合作伙伴认证待处理`;
      this.application.content = content;
      const { data: dt } = await this.$http.post(
        "general/sendMail",
        this.application
      );
      if (dt.status !== 200) {
        return this.$message.error(dt.msg);
      }
    },
    handleRemoveshouquan() {
      this.shouquanhanUpload = false;
    },

    handleExceed() {
      this.$message.warning(`当前只可选择 1个文件`);
    },
    beforeRemove(file) {
      return this.$confirm(`确定移除 ${file.name}？`);
    },
    shouquanhan(param) {
      let file = param.file;
      // FormData 对象
      var form = new FormData();
      // 文件对象
      form.append("file", file); // 通过append向form对象添加数据
      let config = {
        headers: { "Content-Type": "multipart/form-data" }
      };
      this.$http.post("general/upload", form, config).then(res => {
        if (res.data.status !== 200) {
          return this.$message.error(res.data.msg);
        }
        this.$message({
          message: "上传成功",
          type: "success"
        });
        this.shouquanhanU = res.data.data.result;
        this.shouquanhanUpload = true;
      });
    },
    //获取选择的省市
    onChangeProvince(a) {
      this.chengshi = a.value;
    },
    onChangeCity(a) {
      this.shiqu = a.value;
    },
    //上传图片
    license(e) {
      let file = e.target.files[0];
      let param = new FormData(); // 创建form对象
      param.append("file", file); // 通过append向form对象添加数据
      let config = {
        headers: { "Content-Type": "multipart/form-data" }
      };
      this.$http.post("general/upload", param, config).then(response => {
        if (response.data.status == 500) {
          this.$confirm("身份认证过期请重新登陆", "退出", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning"
          })
            .then(() => {
              window.sessionStorage.removeItem("token");
              // window.sessionStorage.removeItem("tempData");
              this.$router.push("/login");
            })
            .catch(() => {});
          // return this.$message.error("身份认证过期请重新登陆");
        }
        if (response.data.status !== 200) {
          return this.$message.error(response.data.msg);
        }
        this.$message({
          message: "上传成功",
          type: "success"
        });
        this.licenseU = response.data.data.result;
        this.licenseUrl =
          this.$http.defaults.baseURL +
          "file" +
          "/" +
          response.data.data.result;

        this.licenseUpload = true;
      });
    },
    //上传图片
    back(e) {
      let file = e.target.files[0];
      let param = new FormData(); // 创建form对象
      param.append("file", file); // 通过append向form对象添加数据
      let config = {
        headers: { "Content-Type": "multipart/form-data" }
      };
      this.$http.post("general/upload", param, config).then(response => {
        if (response.data.status == 500) {
          this.$confirm("身份认证过期请重新登陆", "退出", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning"
          })
            .then(() => {
              window.sessionStorage.removeItem("token");
              // window.sessionStorage.removeItem("tempData");
              this.$router.push("/login");
            })
            .catch(() => {});
          // return this.$message.error("身份认证过期请重新登陆");
        }
        if (response.data.status !== 200) {
          return this.$message.error(response.data.msg);
        }
        this.$message({
          message: "上传成功",
          type: "success"
        });
        this.backU = response.data.data.result;
        this.backUrl =
          this.$http.defaults.baseURL +
          "file" +
          "/" +
          response.data.data.result;
        this.backUpload = true;
      });
    },
    //上传图片
    positive(e) {
      let file = e.target.files[0];
      let param = new FormData(); // 创建form对象
      param.append("file", file); // 通过append向form对象添加数据
      let config = {
        headers: { "Content-Type": "multipart/form-data" }
      };
      this.$http.post("general/upload", param, config).then(response => {
        if (response.data.status !== 200) {
          return this.$message.error(response.data.msg);
        }
        this.$message({
          message: "上传成功",
          type: "success"
        });
        this.positiveU = response.data.data.result;
        this.positiveUrl =
          this.$http.defaults.baseURL +
          "file" +
          "/" +
          response.data.data.result;
        this.positiveUpload = true;
      });
    },
    //获取session中数据
    async sessionData() {
      let config = {
        headers: { "Content-Type": "application/x-www-form-urlencoded" }
      };
      const { data: dt } = await this.$http.post(
        "user/getUserInfo",
        "",
        config
      );
      if (dt.status == 500) {
        this.$confirm("身份认证过期请重新登陆", "退出", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        })
          .then(() => {
            window.sessionStorage.removeItem("token");
            // window.sessionStorage.removeItem("tempData");
            this.$router.push("/login");
          })
          .catch(() => {});
        // return this.$message.error("身份认证过期请重新登陆");
      }
      this.testData = dt.data;
      this.testData.auth.forEach(e => {
        if (e.type == 1) {
          if (e.status == 2) {
            this.bohuizhuantai = true;
          }
        }
      });
      this.udate.id = this.testData.id;
      this.userForm.companyName = this.testData.companyName;
      if (this.testData.hasOwnProperty("data")) {
        this.testData.data = JSON.parse(this.testData.data);

        if (this.testData.data.hasOwnProperty("bohuiyuanyin")) {
          this.userForm.bohuiyuanyin = this.testData.data.bohuiyuanyin;
        }
        if (this.testData.data.hasOwnProperty("companyAddress")) {
          this.userForm.companyAddress = this.testData.data.companyAddress;
        }
        if (this.testData.data.hasOwnProperty("name")) {
          this.userForm.name = this.testData.data.name;
        }
        if (this.testData.data.hasOwnProperty("contacts")) {
          this.userForm.contacts = this.testData.data.contacts;
        }

        if (this.testData.data.hasOwnProperty("positiveUrl")) {
          this.positiveUrl =
            this.$http.defaults.baseURL +
            "file" +
            "/" +
            this.testData.data.positiveUrl;
          this.positiveU = this.testData.data.positiveUrl;
          this.positiveUpload = true;
        }
        if (this.testData.data.hasOwnProperty("backUrl")) {
          this.backUrl =
            this.$http.defaults.baseURL +
            "file" +
            "/" +
            this.testData.data.backUrl;
          this.backU = this.testData.data.backUrl;
          this.backUpload = true;
        }
        if (this.testData.data.hasOwnProperty("licenseUrl")) {
          this.licenseUrl =
            this.$http.defaults.baseURL +
            "file" +
            "/" +
            this.testData.data.licenseUrl;
          this.licenseU = this.testData.data.licenseUrl;
          this.licenseUpload = true;
        }
        if (this.testData.data.hasOwnProperty("shouquanhanUrl")) {
          this.shouquanhanxiazai =
            this.$http.defaults.baseURL +
            "file" +
            "/" +
            this.testData.data.shouquanhanUrl;
          this.shouquanhanU = this.testData.data.shouquanhanUrl;
          this.shouquanhanUpload = true;
        }
      }
    },
    submission() {
      //发送验证请求
      // console.log(this.chengshi + this.shiqu + this.userForm.companyAddress);
      if (this.shouquanhanUpload == false) {
        return this.$message.error("请上传授权函");
      }
      if (this.licenseUpload == false) {
        return this.$message.error("请上传营业执照/政府机关证明照片");
      }
      if (this.backUpload == false) {
        return this.$message.error("请上传身份信息照片");
      }
      if (this.positiveUpload == false) {
        return this.$message.error("请上传身份信息照片");
      }

      this.$refs.userForm.validate(valid => {
        if (valid) {
          this.$confirm("确认要提交认证么?", "提交", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning"
          })
            .then(async () => {
              if (this.testData.hasOwnProperty("data")) {
                if (this.testData.data.hasOwnProperty("beifen")) {
                  this.testData.data.beifen = JSON.parse(
                    this.testData.data.beifen
                  );
                  this.testData.data.beifen.companyAddress =
                    this.chengshi + this.shiqu + this.userForm.companyAddress;

                  this.testData.data.beifen.name = this.userForm.name;
                  this.testData.data.beifen.contacts = this.userForm.contacts;

                  this.testData.data.beifen.positiveUrl = this.positiveU;
                  this.testData.data.beifen.backUrl = this.backU;
                  this.testData.data.beifen.licenseUrl = this.licenseU;
                  this.testData.data.beifen.shouquanhanUrl = this.shouquanhanU;
                } else {
                  this.testData.data.beifen = {};
                  this.testData.data.beifen.companyAddress =
                    this.chengshi + this.shiqu + this.userForm.companyAddress;
                  this.testData.data.beifen.name = this.userForm.name;
                  this.testData.data.beifen.contacts = this.userForm.contacts;
                  this.testData.data.beifen.positiveUrl = this.positiveU;
                  this.testData.data.beifen.backUrl = this.backU;
                  this.testData.data.beifen.licenseUrl = this.licenseU;
                  this.testData.data.beifen.shouquanhanUrl = this.shouquanhanU;
                }
              }
              this.companydate.userJsonData.data = this.testData.data;
              this.companydate.userJsonData.data.beifen = JSON.stringify(
                this.companydate.userJsonData.data.beifen
              );
              this.companydate.userJsonData.data = JSON.stringify(
                this.companydate.userJsonData.data
              );
              this.companydate.userJsonData = JSON.stringify(
                this.companydate.userJsonData
              );

              const { data: dt } = await this.$http.post(
                "user/auth",
                this.companydate
              );

              if (dt.status !== 200) {
                return this.$message.error(dt.msg);
              }
              this.submit();
              this.$message({
                message: "提交成功",
                type: "success"
              });

              this.$router.push("/users");
            })
            .catch(() => {});
        }
      });
    }
  }
};
</script>

<style lang="less" scoped>
.bitianshangchuan {
  color: #606266;
  font-size: 14px;
}
i {
  font-style: normal;
}

.el-card {
  // width: 100%;
  // height: 100%;
  // position: relative;
  // overflow: auto;
  margin-bottom: 30px;
  // .content {
  //   display: flex;
  //   justify-content: flex-end;
  // }
  .xingxi {
    // width: 110px;
    // position: absolute;
    // left: 50px;
    // top: 60px;
    // margin-left: 50px;
    margin-top: 20px;
    margin-bottom: 20px;
    .tiao {
      width: 4px;
      height: 15px;
      background: rgba(0, 134, 253, 1);
      display: inline-block;
      margin-right: 10px;
    }
    i {
      // width: 65px;
      font-weight: bold;
      font-size: 16px;
    }
  }
  // .biaodan {
  //   // width: 327px;
  //   // // height: 342px;
  //   // // position: absolute;
  //   // // top: 150px;
  //   // // left: 80px;
  //   // margin-left: 100px;
  //   // margin-top: 40px;
  //   // margin-right: 100px;
  // }
  .shangchuan {
    // margin-right: auto;
    // // width: 600px;
    // // height: 400px;
    // // position: absolute;
    // // top: 150px;
    // // left: 700px;
    // margin-left: 150px;
    // margin-top: 40px;

    .zhengmian {
      display: inline-block;
      width: 250px;
      height: 134px;
      margin-right: 20px;
      position: relative;
      img {
        width: 100%;
        height: 100%;
      }

      .fileOne {
        width: 100%;
        height: 100%;
        opacity: 0;
        position: absolute;
        top: 0;
        left: 0;
        z-index: 9;
        cursor: pointer;
      }
      .mask {
        display: inline-block;
        width: 250px;
        height: 134px;
        position: absolute;
        top: 0;
        left: 0;
        opacity: 0;
      }
    }
    .zhengmian:hover .mask {
      opacity: 1;
    }
    .fanmian {
      display: inline-block;
      width: 250px;
      height: 134px;

      position: relative;
      img {
        width: 100%;
        height: 100%;
      }

      .fileOne {
        width: 100%;
        height: 100%;
        opacity: 0;
        position: absolute;
        top: 0;
        left: 0;
        z-index: 9;
        cursor: pointer;
      }
      .mask {
        display: inline-block;
        width: 250px;
        height: 134px;
        position: absolute;
        top: 0;
        left: 0;
        opacity: 0;
      }
    }
    .fanmian:hover .mask {
      opacity: 1;
    }
    .zhizhao {
      // display: inline-block;
      width: 250px;
      height: 134px;
      position: relative;

      img {
        width: 100%;
        height: 100%;
      }
      .fileOne {
        width: 100%;
        height: 100%;
        opacity: 0;
        position: absolute;
        top: 0;
        left: 0;
        z-index: 9;
        cursor: pointer;
      }
      .mask {
        display: inline-block;
        width: 250px;
        height: 134px;
        position: absolute;
        top: 0;
        left: 0;
        opacity: 0;
      }
    }
    .zhizhao:hover .mask {
      opacity: 1;
    }
  }
  .tijiao-button {
    text-align: center;
    // position: absolute;
    // left: 50%;
    // top: 850px;
    // transform: translateX(-50%);
    margin-top: 20px;
    .el-button {
      width: 260px;
      height: 50px;
    }
  }
}
</style>
